var React = require('react');

function ItemNotSelected (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#FFF","cx":"7.5","cy":"7.75","r":"7.258","key":0}),React.createElement("path",{"fill":"#E6E6E6","d":"M7.5 15.25c-4.136 0-7.5-3.364-7.5-7.5S3.364.25 7.5.25 15 3.614 15 7.75s-3.364 7.5-7.5 7.5zM7.5.734C3.631.734.484 3.882.484 7.75s3.148 7.016 7.016 7.016 7.016-3.148 7.016-7.016S11.369.734 7.5.734z","key":1})]);
}

ItemNotSelected.defaultProps = {"width":"15","height":"15.5","viewBox":"0 0 15 15.5"};

module.exports = ItemNotSelected;

ItemNotSelected.default = ItemNotSelected;
